import { noop } from '../utils/noop.mjs';
import { createRenderBatcher } from './batcher.mjs';
var _createRenderBatcher = createRenderBatcher(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : noop, true),
  frame = _createRenderBatcher.schedule,
  cancelFrame = _createRenderBatcher.cancel,
  frameData = _createRenderBatcher.state,
  steps = _createRenderBatcher.steps;
export { cancelFrame, frame, frameData, steps };